<template>
  <div class="json-nested-viewer" :class="{ 'json-nested-viewer--compact': compact }">
    <div v-if="isEmpty" class="json-nested-empty">{{ emptyText }}</div>
    <json-nested-block
      v-else
      :value="displayValue"
      :depth="0"
      :compact="compact"
      :field-labels="mergedFieldLabels"
      :max-nested-table-height="maxHeight"
    />
  </div>
</template>

<script>
import JsonNestedBlock from './JsonNestedBlock.vue';
import { parseJsonValue } from '@/utils/jsonNestedTable';
import { normalizePushDataForView, getPushDataFieldLabels } from '@/utils/poOtherDataView';

export default {
  name: 'JsonNestedTable',
  components: { JsonNestedBlock },
  props: {
    data: { default: null },
    /** 综合 PO Tab 名，用于按 online 结构归一化 data */
    viewKey: { type: String, default: '' },
    compact: { type: Boolean, default: false },
    emptyText: { type: String, default: '暂无数据' },
    fieldLabels: { type: Object, default: () => ({}) },
    maxHeight: { type: Number, default: 480 },
  },
  computed: {
    displayValue() {
      if (this.viewKey) {
        return normalizePushDataForView(this.viewKey, this.data);
      }
      return this.data;
    },
    mergedFieldLabels() {
      const extra = this.viewKey ? getPushDataFieldLabels(this.viewKey) : {};
      return { ...extra, ...this.fieldLabels };
    },
    parsed() {
      return parseJsonValue(this.displayValue);
    },
    isEmpty() {
      const v = this.parsed;
      if (v === null || v === undefined || v === '') return true;
      if (Array.isArray(v) && v.length === 0) return true;
      if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return true;
      return false;
    },
  },
};
</script>

<style scoped>
.json-nested-viewer {
  width: 100%;
  max-height: 70vh;
  overflow: auto;
  padding: 4px 0;
}

.json-view-dialog-body {
  min-width: 0;
}

.json-nested-empty {
  color: #909399;
  text-align: center;
  padding: 24px 0;
  font-size: 13px;
}
</style>
